import axios from "axios";

const getBranchList = async (companyId) => {
  try {
    const response = await axios.get(
      "/consumer/system-admin/api/v1/data-summary/branch-list",
      {
        params: {
          company_id: companyId,
        },
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    const errorResponse = {
      success: false,
      error: error.response?.data?.message || error.message,
      code: error.response?.data?.code || "ERROR_UNKNOWN",
      data: [],
      details: error.response?.data?.data || null,
    };
    throw errorResponse;
  }
};

export default getBranchList;
